/**
 * Modal layout and default content constants.
 */

export const MODAL_TYPES = {
	FUND: 'fund',
	CAPITAL: 'capital',
};

export const FUND_LAYOUT_VARIANTS = {
	FULL_WIDTH_CTA: 'full-width-cta',
	SPLIT_CTA: 'split-cta',
};

export const FUND_LAYOUT_OPTIONS = [
	{
		label: 'Conventional',
		value: FUND_LAYOUT_VARIANTS.FULL_WIDTH_CTA,
	},
	{
		label: 'Shariah',
		value: FUND_LAYOUT_VARIANTS.SPLIT_CTA,
	},
];

export const CAPITAL_TABLE_BORDER = '#D7DFDF';

const MURABAHA_OVERVIEW = [
	{ label: 'Investment structure', value: 'Murabaha' },
	{ label: 'Currency', value: 'SAR' },
	{ label: 'Target investment horizon', value: 'Open-ended' },
	{ label: 'Distribution frequency', value: 'Quarterly' },
	{ label: 'Minimum investment', value: 'SAR 1,000,000' },
	{
		label: 'Investor qualification',
		value: 'Retail, qualified & institutional investors',
	},
];

const MUSHARAKA_OVERVIEW = [
	{ label: 'Investment structure', value: 'Musharaka' },
	{ label: 'Currency', value: 'SAR' },
	{ label: 'Target investment horizon', value: 'Open-ended' },
	{ label: 'Distribution frequency', value: 'Annual' },
	{ label: 'Minimum investment', value: 'SAR 10,000' },
	{
		label: 'Investor qualification',
		value: 'Retail, qualified & institutional investors',
	},
];

const ALFOWZAN_OVERVIEW = [
	{ label: 'Investment structure', value: 'Murabaha' },
	{ label: 'Currency', value: 'SAR' },
	{ label: 'Target investment horizon', value: 'Open-ended' },
	{ label: 'Distribution frequency', value: 'Quarterly' },
	{ label: 'Minimum investment', value: 'SAR 1,000,000' },
	{
		label: 'Investor qualification',
		value: 'Retail, qualified & institutional investors',
	},
];

export const CAPITAL_MODAL_DEFAULTS = {
	'alteia-saudi-murabaha': {
		aboutTheFund:
			'The Alteia Saudi Murabaha Fund provides investors with access to Shariah-compliant financing opportunities through Murabaha transactions within Saudi Arabia and the GCC.',
		investmentObjective:
			'The fund seeks to provide investors with exposure to trade finance opportunities linked to the movement of physical goods while maintaining a disciplined, asset-backed investment approach.',
		fundOverview: MURABAHA_OVERVIEW,
		investmentCharacteristics: [
			'Short-duration trade finance strategy',
			'Asset-backed transactions',
			'Financing linked to real commercial activity',
			'Diversified portfolio across counterparties and sectors',
			'Active monitoring throughout the investment lifecycle',
		],
		fundDocuments: [],
		interestedHeading: 'Interested in this fund?',
		interestedText:
			'Contact our Investor Relations team to request additional information or discuss subscription opportunities.',
		ctaLabel: 'Contact us',
		ctaUrl: '',
		ctaOpensInNewTab: true,
	},
	'alteia-saudi-musharaka': {
		aboutTheFund:
			'The Alteia Saudi Musharaka Fund provides investors with access to partnership-based investments structured through Musharaka arrangements in accordance with Shariah principles.',
		investmentObjective:
			'The fund seeks to provide investors with access to commercial opportunities through disciplined governance and a partnership-based investment approach.',
		fundOverview: MUSHARAKA_OVERVIEW,
		investmentCharacteristics: [
			'Partnership-based investment structure',
			'Participation in commercial ventures',
			'Longer investment horizon',
			'Diversified sector exposure',
			'Ongoing portfolio oversight',
		],
		fundDocuments: [],
		interestedHeading: 'Interested in this fund?',
		interestedText:
			'Contact our Investor Relations team to request additional information or discuss subscription opportunities.',
		ctaLabel: 'Contact us',
		ctaUrl: '',
		ctaOpensInNewTab: true,
	},
	'alfowzan-murabaha': {
		aboutTheFund:
			'The Alfowzan Murabaha Fund provides investors with access to Murabaha financing opportunities through a strategic partnership with Alfowzan Holding.',
		investmentObjective:
			'The fund seeks to provide investors with exposure to Murabaha financing opportunities supported by established counterparties across Saudi Arabia and the GCC.',
		fundOverview: ALFOWZAN_OVERVIEW,
		investmentCharacteristics: [
			'Asset-backed trade finance strategy',
			'Short-duration commercial transactions',
			'Financing linked to real commercial activity',
			'Exposure to established counterparties',
			'Active monitoring throughout the investment lifecycle',
		],
		fundDocuments: [],
		interestedHeading: 'Interested in this fund?',
		interestedText:
			'Contact our Investor Relations team to request additional information or discuss subscription opportunities.',
		ctaLabel: 'Contact us',
		ctaUrl: '',
		ctaOpensInNewTab: true,
	},
};

/**
 * Resolve capital modal defaults by content id.
 *
 * @param {string} modalContentId Modal content identifier.
 * @return {Object} Capital modal content defaults.
 */
export function getCapitalModalDefaults( modalContentId ) {
	return (
		CAPITAL_MODAL_DEFAULTS[ modalContentId ] || {
			aboutTheFund: '',
			investmentObjective: '',
			fundOverview: [],
			investmentCharacteristics: [],
			fundDocuments: [],
			interestedHeading: 'Interested in this fund?',
			interestedText: '',
			ctaLabel: 'Contact us',
			ctaUrl: '',
			ctaOpensInNewTab: true,
		}
	);
}

/**
 * Fund modal block area map per layout variant.
 */
export const FUND_GRID_AREAS = {
	[ FUND_LAYOUT_VARIANTS.FULL_WIDTH_CTA ]: {
		overview: 'overview',
		left: 'left',
		right: 'right',
	},
	[ FUND_LAYOUT_VARIANTS.SPLIT_CTA ]: {
		overview: 'overview',
		left: 'left',
		right: 'right',
	},
};

export const MODAL_BODY_CLASS = 'alteia-mtm-modal-open';
